/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsownstart3Inputs */

const en_ticketspayoutsownstart3 = /** @type {(inputs: Ticketspayoutsownstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up own account`)
};

const de_ticketspayoutsownstart3 = /** @type {(inputs: Ticketspayoutsownstart3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Konto einrichten`)
};

/**
* | output |
* | --- |
* | "Set up own account" |
*
* @param {Ticketspayoutsownstart3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsownstart3 = /** @type {((inputs?: Ticketspayoutsownstart3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsownstart3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsownstart3(inputs)
	return de_ticketspayoutsownstart3(inputs)
});
export { ticketspayoutsownstart3 as "ticketsPayoutsOwnStart" }